<template>
  <div
    :class="[
      'max-w-64 py-2 px-2 text-xs bg-gray-600 text-gray-100 absolute top-5 left-5 px-1 rounded bg-opacity-50 shadow-xl whitespace-nowrap',
      show ? 'inline-block' : 'hidden'
    ]"
  >
    {{ label }}
  </div>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    label: {
      type: String
    }
  }
}
</script>
